import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, Form } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { fromJS } from 'immutable';
import { findCountry } from '../../../utils/countries';
import { required } from '../../../utils/formvalidation';

import ReduxDialog from '../../Common/ReduxDialog';
import { renderTextField } from '../../../utils/reduxforms.js';
import { hideDialog } from '../../../redux/actions/dialogs';

import { getDialogContextValue } from '../../../redux/selectors';
import { ADDRESS_DIALOG } from '../../../redux/constants/dialogs';
import { renderCountry } from '../../../utils/reduxforms';

import styles from './styles';

class AddressDialog extends React.Component {
  state = {};

  render() {
    const { handleSubmit, initialValues, hideDialog, submit } = this.props;

    const actions = [
      <Button
        key="cancel"
        variant="text"
        onClick={() => hideDialog(ADDRESS_DIALOG)}
      >Cancel</Button>,
      <Button
        key="save"
        variant="contained"
        color="primary"
        autoFocus
        onClick={submit}
      >Save</Button>,
    ];

    return (
      <ReduxDialog
        name={ADDRESS_DIALOG}
        title={initialValues && initialValues.get('id') ? initialValues.get('line1') : 'Create New Address'}
        actions={actions}
        modal={false}
      >
        <Form onSubmit={handleSubmit} style={styles.body}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Field
                name="name"
                component={renderTextField}
                label="Name"
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                name="line1"
                component={renderTextField}
                label="Line 1"
                fullWidth
                validate={required}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                name="line2"
                component={renderTextField}
                label="Line 2"
                fullWidth
              />
            </Grid>
            {/* <Field*/}
            {/* name="building"*/}
            {/* component={TextField}*/}
            {/* label="Building"*/}
            {/* InputLabelProps={{shrink: true}}*/}
            {/* fullWidth*/}
            {/* style={commonStyles.input}*/}
            {/* />*/}
            <Grid item xs={6}>
              <Field
                name="city"
                component={renderTextField}
                label="City"
                fullWidth
                validate={required}
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                name="state"
                component={renderTextField}
                label="State"
                fullWidth
                validate={required}
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                name="postalCode"
                component={renderTextField}
                label="Postal Code"
                fullWidth
                validate={required}
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                component={renderCountry}
                name="country"
                label="Country"
                fullWidth
                validate={required}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                name="notes"
                component={renderTextField}
                label="Notes"
                fullWidth
                multiline
                rows={3}
              />
            </Grid>
          </Grid>
        </Form>
      </ReduxDialog>
    );
  }
}

AddressDialog.propTypes = {
  onSave: PropTypes.func,
  onSuccess: PropTypes.func,
};

const form = reduxForm({
  form: ADDRESS_DIALOG,  // a unique identifier for this form
  onSubmit: (values, dispatch, props) => {
    return props.onSave ? props.onSave(values.toJS()) : values.toJS();
  },
  onSubmitSuccess: (result, dispatch, props) => {
    console.log('result', result);
    props.onSuccess && props.onSuccess(result);
    props.hideDialog(ADDRESS_DIALOG);
  },
  onSubmitFail: (errors, dispatch, submitError, props) => {
    console.log('onSubmitFail', errors, submitError);
  },
})(AddressDialog);

function mapStateToProps(state) {
  const initialValues = (getDialogContextValue(state)(ADDRESS_DIALOG, 'address') || new Map());
  return {
    initialValues: initialValues.set('country', initialValues.get('country') || fromJS(findCountry('US'))),
    onSave: getDialogContextValue(state)(ADDRESS_DIALOG, 'onSave'),
    onSuccess: getDialogContextValue(state)(ADDRESS_DIALOG, 'onSuccess'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Addresses/AddressDialog/index.js